var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16V14C15.45 13.777 16.737 12.245 16.872 11.048C17.226 11.021 17.782 10.696 17.946 9.41298C18.034 8.72398 17.684 8.33698 17.472 8.21498C17.472 8.21498 18 7.21198 18 6.00098C18 3.57298 17.047 1.50098 15 1.50098C15 1.50098 14.289 0.000976562 12 0.000976562C7.758 0.000976562 6 2.72198 6 6.00098C6 7.10498 6.528 8.21498 6.528 8.21498C6.316 8.33698 5.966 8.72498 6.054 9.41298C6.218 10.696 6.774 11.021 7.128 11.048C7.263 12.245 8.55 13.777 9 14V16C8 19 0 17 0 24H24C24 17 16 19 15 16Z",
    fill: "#76767A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.bd69b05073fa556f97c8b37ec208cb73.svg";
export { ForwardRef as ReactComponent };